import { render, staticRenderFns } from "./PrvcyAgr.vue?vue&type=template&id=39a5c2fc&"
import script from "./PrvcyAgr.vue?vue&type=script&lang=js&"
export * from "./PrvcyAgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports